<div class="owner">
    {#if canEdit && publicAccessUrl}
        <button type="button" aria-label={terms.shareDialogTerms.shareYourPortfolio} class="share-button" on:click={shareLink}></button>
    {/if}
    <header class="owner-info">
        {#if owner.pictureUrl}
            <div class="avatar">
                <Avatar src={owner.pictureUrl} size=600 />
            </div>
        {/if}
        <div class="name">
            <h1>{owner.name}</h1>
        </div>
        {#if owner.email}
            <div class="email">{owner.email}</div>
        {/if}
        {#if canEdit}
            <div class="edit-owner-info">
                <button bind:this={editButton} class="edit-owner-info-button" on:click={onEditClick}>{terms.edit}</button>
            </div>
        {/if}
    </header>
    {#if owner.summary || canEdit}
        <section class="summary">
            <h2>{terms.aboutMe}</h2>
            <span class="text">{(owner.summary && owner.summary.length ? owner.summary : terms.aboutMeWatermark)}</span>
        </section>
    {/if}
</div>
<script>
    import { createEventDispatcher } from 'svelte';

    import Avatar from '@itslearning/prometheus/assets/images/Avatar/v1/Avatar.svelte';

    export let owner = {};
    export let terms = {};
    export let publicAccessUrl = '';
    export let canEdit = false;

    const dispatch = createEventDispatcher();

    let editButton;

    function shareLink() {
        if (!canEdit) {
            return;
        }

        dispatch('showShareDialog', {});
    }

    function onEditClick() {
        if (!canEdit) {
            return;
        }

        dispatch('editPortfolioOwner', {});
    }

    export function setFocusOnEditButton() {
        editButton.focus();
    }
</script>
